import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ErrorDialogModule } from '@portal-core/general/components/error-dialog/error-dialog.module';
import { FlareTextEditorModule } from '@portal-core/project-files/components/flare-text-editor/flare-text-editor.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { ReviewFileAvatarModule } from '@portal-core/reviews/review-files/components/review-file-avatar/review-file-avatar.module';
import { ReviewPackageAvatarModule } from '@portal-core/reviews/review-packages/components/review-package-avatar/review-package-avatar.module';
import { ReviewPackageAsyncModule } from '@portal-core/reviews/review-packages/pipes/review-package-async/review-package-async.module';
import { FlareFileReviewerComponent } from './flare-file-reviewer.component';

@NgModule({
  declarations: [FlareFileReviewerComponent],
  imports: [
    CommonModule,
    ErrorDialogModule,
    FlareTextEditorModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatToolbarModule,
    MatTooltipModule,
    ProjectAsyncModule,
    ProjectAvatarModule,
    ReviewFileAvatarModule,
    ReviewPackageAvatarModule,
    ReviewPackageAsyncModule,
    MatSnackBarModule
  ],
  exports: [FlareFileReviewerComponent]
})
export class FlareFileReviewerModule {
}
